import { Component, HostBinding, Input, OnInit } from '@angular/core';

import { Project } from '../project.model';

@Component({
    selector: 'app-project-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.min.css'],
})
export class ProjectItemComponent implements OnInit {
    @HostBinding('style.background-image') public backgroundImage: string;
    @Input() public project: Project;

    ngOnInit() {
        this.backgroundImage = `url('/assets/project-images/${this.project.image}')`;
    }
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/item/item.component.ts